/* eslint-disable import/no-extraneous-dependencies */
import 'firebase/messaging';

import firebase from 'firebase/app';

import configuration from 'configuration';

// eslint-disable-next-line import/no-mutable-exports
let messaging;

try {
  messaging = firebase.messaging();
} catch (err) {
  console.log(err);
}
firebase.initializeApp(configuration.FIREBASE);

export default messaging;
